<template lang="pug">
  section.kr-sf-opm
    label.kr-sf-opm__label(v-show="showOpmLabel") {{ label | capitalize | colon }}
    EmbeddedMethodDisplay(v-if="effectiveColumns && effectiveColumns > 1")
    .kr-sf-opm__methods
      SmartFormGridOpmGroup(
        type="main",
        :class="dynamicClasses('main')",
        :methods="mainPaymentMethods",
        v-on:selected="onSelected",
        :locked="isFormLocked"
        @effectiveColumnChange="mainColChange"
      )
      SmartFormGridOpmGroup(
        type="group",
        :group="group",
        :class="dynamicClasses('group')",
        :methods="groupPaymentMethods",
        v-on:selected="onSelected",
        :locked="isFormLocked"
        @back="goBack()"
      )
    SmartFormGridError
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

import SmartFormGridOpmGroup from '@/host/components/smartform/grid/opm/Group'
import SmartFormGridError from '@/host/components/smartform/grid/Error'
import EmbeddedMethodDisplay from '@/host/components/smartform/grid/embeddedMethod/EmbeddedMethodDisplay'

export default {
  name: 'SmartFormGridOtherMethods',
  components: {
    SmartFormGridOpmGroup,
    SmartFormGridError,
    EmbeddedMethodDisplay
  },
  data() {
    return {
      group: ''
    }
  },
  computed: {
    ...mapGetters([
      'translate',
      'hasSeveralPaymentMethods',
      'isWalletSmartForm',
      'hasTokens',
      'hasCardFormExpandedInside',
      'hasOtherPaymentMethods',
      'showOpmLabel',
      'isFormLocked',
      'isRegisterMode',
      'activeEmbeddedMethod',
      'numOfPaymentMethods'
    ]),
    ...mapGetters({
      paymentMethodGroups: 'effectivePaymentMethodGroupList'
    }),
    ...mapState({
      currentView: state =>
        state.smartForm.otherPaymentMethods.navigation.currentView,
      views: state => state.smartForm.otherPaymentMethods.navigation.views,
      history: state => state.smartForm.otherPaymentMethods.navigation.history,
      effectiveColumns: state =>
        state.smartForm.otherPaymentMethods.grid.effectiveColumns
    }),
    ...mapState({
      otherMethodsLabel: ({ smartForm }) => smartForm.labels.otherPaymentMethods
    }),
    mainPaymentMethods() {
      let methods = []
      // Non-grouped methods
      methods = methods.concat(
        this.paymentMethodGroups.single
          .filter(method => {
            return method !== 'CARDS' && method !== 'CARDS:ILLICADO'
          })
          .map(method => {
            return {
              type: 'method',
              key: method
            }
          })
      )
      // Groups
      for (const group in this.paymentMethodGroups) {
        if (group !== 'single' && this.paymentMethodGroups[group].length > 0)
          methods.push({
            type: 'group',
            key: group
          })
      }
      // Illicado
      if (this.paymentMethodGroups.single.includes('CARDS:ILLICADO')) {
        methods.unshift({
          type: 'method',
          key: 'CARDS:ILLICADO'
        })
      }

      return methods
    },
    groupPaymentMethods() {
      if (this.group) {
        return this.paymentMethodGroups[this.group].map(method => {
          return {
            type: 'method',
            key: method
          }
        })
      }
      return []
    },
    activeLevel() {
      return this.views.indexOf(this.currentView)
    },
    walletMode() {
      return this.isWalletSmartForm && this.hasTokens
    },
    label() {
      if (this.isRegisterMode) {
        return this.translate('smartform_register_another_payment_method')
      }

      // Customized label
      if (this.otherMethodsLabel) return `${this.otherMethodsLabel}:`
      return this.translate(
        this.hasSeveralPaymentMethods
          ? 'smartform_other_payment_methods'
          : 'smartform_other_payment_method'
      )
    },
    dynamicClasses() {
      return view => ({
        [`kr-opm-group--level-${this.activeLevel}`]: true,
        'kr-opm-group--active': this.currentView === view
      })
    }
  },
  methods: {
    ...mapActions(['opmNavigate', 'cleanError', 'setDefaultActiveMethod']),
    onSelected(method) {
      if (this.isGroup(method)) {
        this.cleanError()
        this.group = method.key
        this.setDefaultActiveMethod()
        this.opmNavigate(method.type)
        return
      }
      this.$emit('selected', method.key)
    },
    isGroup(method) {
      return method.type === 'group'
    },
    goBack() {
      this.cleanError()
      this.group = ''
      this.opmNavigate('main')
    },
    mainColChange(colAmount) {
      /**
       * if the number of columns is 2, the numOfPaymentMethods is 1 and there is an activeEmbeddedMethod,
       * that means that the activeEmbeddedMethod has been removed from the list.
       * If there were 2 elements in 2 columns we will  recompute just 1 column.
       * This will make the getter that filters to not filter the activeEmbeddedMethod, reaching the initial situation and looping
       * To avoid this we don't touch the number of columns in this specific case. since KJS-5138
       */
      if (
        this.activeEmbeddedMethod &&
        this.numOfPaymentMethods === 1 &&
        this.effectiveColumns === 2
      )
        return
      this.$store.dispatch('update', {
        smartForm: {
          otherPaymentMethods: {
            grid: { effectiveColumns: colAmount }
          }
        }
      })
    }
  }
}
</script>
